module.exports = __webpack_public_path__ + "static/media/icon-clock.341a1841.svg";